module.exports = __webpack_public_path__ + "img/america-2.832a9e7f.png";